import React, { useState, useEffect } from 'react';
import { ChevronDown, Menu, X } from 'lucide-react';
import { whatsappLink, navServices, brand } from '../data/mock';

const Logo = () => (
  <a href="#top" className="flex items-center gap-3 select-none">
    <img
      src={brand.logo}
      alt="BRN"
      className="h-10 md:h-11 w-auto"
      style={{ filter: 'invert(1) brightness(1.1)' }}
    />
    <span className="hidden sm:block font-italiana text-[12px] tracking-[0.4em] text-cream/85 mt-1">
      BARBEARIA
    </span>
  </a>
);

const NavLink = ({ children, href = '#', hasArrow = false, items = null }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a
        href={href}
        className="flex items-center gap-1.5 text-[14px] text-cream/85 hover:text-cream transition-colors font-body"
      >
        {children}
        {hasArrow && <ChevronDown className="w-3.5 h-3.5 opacity-70" />}
      </a>
      {hasArrow && items && open && (
        <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 z-50">
          <div className="min-w-[220px] rounded-2xl border border-cream/10 bg-[#161210]/95 backdrop-blur-md shadow-2xl py-2">
            {items.map((it) => (
              <a
                key={it}
                href="#servicos"
                className="block px-5 py-2.5 text-[13.5px] text-cream/80 hover:text-cream hover:bg-cream/[0.04] transition-colors"
              >
                {it}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header id="top" className="fixed top-0 left-0 right-0 z-50 px-4 md:px-8 pt-4 md:pt-6">
      <div
        className={`mx-auto max-w-6xl rounded-full border border-cream/10 transition-all duration-500 ${
          scrolled ? 'bg-[#100c0a]/90 backdrop-blur-xl' : 'bg-[#171311]/70 backdrop-blur-md'
        }`}
      >
        <div className="flex items-center justify-between px-5 md:px-7 py-3">
          <Logo />

          <nav className="hidden lg:flex items-center gap-8">
            <NavLink href="#conceito">A BRN</NavLink>
            <NavLink href="#servicos" hasArrow items={navServices}>Serviços</NavLink>
            <NavLink href="#unidade">Unidade</NavLink>
            <NavLink href="#contato">Contato</NavLink>
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="hidden sm:inline-flex items-center justify-center rounded-full bg-cream text-[#0b0807] px-7 py-2.5 text-sm font-medium tracking-wide hover:bg-white transition-colors"
            >
              Agendar
            </a>
            <button
              className="lg:hidden p-2 text-cream"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menu"
            >
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="lg:hidden px-6 pb-6 pt-2 border-t border-cream/10">
            <div className="flex flex-col gap-4 pt-4">
              <a href="#conceito" onClick={() => setMobileOpen(false)} className="text-cream/85 text-sm">A BRN</a>
              <a href="#servicos" onClick={() => setMobileOpen(false)} className="text-cream/85 text-sm">Serviços</a>
              <a href="#unidade" onClick={() => setMobileOpen(false)} className="text-cream/85 text-sm">Unidade</a>
              <a href="#contato" onClick={() => setMobileOpen(false)} className="text-cream/85 text-sm">Contato</a>
              <a href={whatsappLink} target="_blank" rel="noreferrer" className="sm:hidden inline-flex w-fit rounded-full bg-cream text-[#0b0807] px-6 py-2 text-sm font-medium">Agendar</a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
